import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import { StyledSduCompliance } from '../../VeloAIAssistant.styles';

export const LOCALIZED_TEXT = {
  subtitle: 'businessProfile.aiAssistant.sduCompliance.description',
  buttonLabel: 'businessProfile.aiAssistant.sduCompliance.buttonLabel'
};

export function getUpsellVersionFromConfig(entitlements, upsellConfig) {
  for (const [version, config] of Object.entries(upsellConfig)) {
    if (config.shouldShow(entitlements)) {
      return version;
    }
  }
  return null;
}

function SduCompliance({ entitlements, upsellConfig }) {
  const { formatMessage: fm } = useIntl();
  const dashboardProductsPath = useDashboardPath('/products');

  const upsellVersion = useMemo(
    () => getUpsellVersionFromConfig(entitlements, upsellConfig),
    [entitlements, upsellConfig]
  );

  if (!upsellVersion) return null;

  const config = upsellConfig[upsellVersion];

  return (
    <StyledSduCompliance
      title={fm({ id: config.title })}
      subtitle={fm({ id: LOCALIZED_TEXT.subtitle })}
      clickstreamProps={{ appSection: 'llm_assistant_sdu_compliance' }}
      slotProps={{
        primaryAction: {
          label: fm({ id: LOCALIZED_TEXT.buttonLabel }),
          size: 'sm',
          color: 'secondary',
          to: config.url(dashboardProductsPath)
        }
      }}
      variant="promo"
    />
  );
}

SduCompliance.propTypes = {
  entitlements: PropTypes.instanceOf(Map).isRequired,
  upsellConfig: PropTypes.shape({}).isRequired
};

export default SduCompliance;
